jQuery( function ( $ ) {

    const $load_more_btn = $( '#load-more-faq' );
    if ( !$load_more_btn.length ) { return; }

    const $accordion_group = $load_more_btn.siblings( '.accordion-group' ).first();
    let page = 2;

    $load_more_btn.on( 'click', function () {
        $load_more_btn.attr( 'disabled', true );
        ThemeJS.Functions.wp_rest_request({
            endpoint: 'pharmacy/faq/load',
            data: {
                page
            },
            success ( items ) {
                items.forEach( ( item, index ) => {
                    setTimeout( function () {
                        const $item = $(item).addClass( 'new' );
                        $accordion_group.append( $item );
                        requestAnimationFrame(() => {
                            setTimeout(() => {
                                $item.removeClass( 'new' );
                            });
                        });
                    }, index * 150 );
                });
                page++;
            },
            complete () {
                if ( page > $load_more_btn.data( 'max-page' ) ) {
                    $load_more_btn.remove();
                } else {
                    $load_more_btn.attr( 'disabled', false );
                }
            }
        });
    });

});